import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import * as React from 'react';
import { Link } from 'react-router-dom';

function SimpleDialog(props) {
    const { onClose, selectedValue, open } = props;

    const handleClose = () => {
        onClose(selectedValue);
    };

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle closeButton>{props.title}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={theme => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}>
                <CloseIcon />
            </IconButton>
            <Divider />
            <Box
                margin={1}
                style={{
                    maxHeight: '100%',
                    overflowY: 'scroll',
                    textWrap: 'wrap',
                }}>
                {props.valueType === 'JSON' && <pre>{props.description}</pre>}
                {props.valueType !== 'JSON' && <>{props.description}</>}
            </Box>
        </Dialog>
    );
}

export default function PxPopup(props) {
    const [open, setOpen] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = value => {
        setOpen(false);
        setSelectedValue(value);
    };

    return (
        <div>
            <Link type="a" onClick={handleClickOpen}>
                {props.title}
            </Link>
            <SimpleDialog
                {...props}
                selectedValue={selectedValue}
                open={open}
                title={
                    props.modalTitle
                        ? props.modalTitle
                        : `Details of ${props.title}`
                }
                onClose={handleClose}
            />
        </div>
    );
}
